import { CheckCircle2, XCircle, Play, Loader2 } from "lucide-react";

export const QuestionCard = ({ cp, index, total, answer, busy, onChoose, onContinue, letters }) => (
  <div className="absolute inset-0 flex overflow-y-auto bg-[#0b2545]/95 p-3 sm:p-6" data-testid="video-question">
    <div className="m-auto w-full max-w-2xl space-y-2 text-white sm:space-y-3">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-300">Question {index + 1} of {total}</p>
      <h3 className="font-heading text-base font-semibold leading-snug sm:text-xl" data-testid="video-question-text">{cp.question}</h3>
      <div className="space-y-2">
        {cp.options.map((o, i) => {
          const picked = answer?.selected === i;
          const right = answer && answer.correct_index === i;
          const tone = !answer ? "border-white/25 bg-white/10 hover:bg-white/20" : right ? "border-green-400 bg-green-500/25" : picked ? "border-rose-400 bg-rose-500/25" : "border-white/10 bg-white/5 opacity-60";
          return (
            <button key={i} disabled={!!answer || busy} onClick={() => onChoose(i)}
              className={`flex w-full items-start gap-3 rounded-xl border px-3 py-2.5 text-left text-xs transition-colors sm:text-sm ${tone}`} data-testid={`video-option-${i}`}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20 text-xs font-bold">{letters[i]}</span>
              <span className="flex-1">{o}</span>
              {answer && right && <CheckCircle2 size={16} className="shrink-0 text-green-300" />}
              {answer && picked && !right && <XCircle size={16} className="shrink-0 text-rose-300" />}
            </button>
          );
        })}
      </div>
      {busy && <Loader2 className="animate-spin text-white/70" size={16} />}
      {answer?.explanation && <p className="text-xs text-white/80" data-testid="video-feedback-explanation">{answer.explanation}</p>}
      {answer && (
        <div className="flex flex-wrap items-center justify-between gap-3" data-testid="video-feedback">
          <p className={`text-sm font-semibold ${answer.correct ? "text-green-300" : "text-rose-300"}`} data-testid="video-feedback-text">
            {answer.correct ? "Correct — give yourself a point!" : `Not quite — the answer is ${letters[answer.correct_index]}.`}
          </p>
          <button onClick={onContinue} className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 text-sm font-semibold text-[#0b2545] hover:bg-white/90" data-testid="video-continue"><Play size={13} /> Continue video</button>
        </div>
      )}
    </div>
  </div>
);
